import { showUnavailableOnWeb } from 'utils/webGate';
/**
 * Opening an investment account (onboarding, KYC, document uploads and ISA or
 * JISA transfers in) stays in the mobile app. On web, shows the QR code modal
 * and returns true so the caller can stop.
 */
export const blockInvestOnboardingOnWeb = () => showUnavailableOnWeb('emma://invest/account', 'Set up investment account');
/**
 * Moving money in or out of an investment account and changing Autoinvest stay
 * in the mobile app. On web, shows the QR code modal and returns true so the
 * caller can stop.
 */
export const blockInvestActionOnWeb = (title) => showUnavailableOnWeb('emma://invest', title);
